import { render } from "./globalData.vue?vue&type=template&id=77fdd210&scoped=true"
import script from "./globalData.vue?vue&type=script&lang=js"
export * from "./globalData.vue?vue&type=script&lang=js"

import "./globalData.vue?vue&type=style&index=0&id=77fdd210&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fdd210"]])

export default __exports__